/**
 * Get Tencent CDN base URL based on environment
 */
function getTencentCdnBaseUrl(): string {
  return `https://${import.meta.env.VITE_TENCENT_CDN_HOST}`;
}

/**
 * Construct deal image URL using Tencent CDN structure
 * Template: {TENCENT_IMAGE_URL_ROOT}/images/products/{product_id}/main/{image_name}/{image_type}_{image_resolution}
 */
export function getDealImageUrl(
  productId: string,
  imageName: string,
  imageType = "full",
  imageResolution = "2x",
  additionalParams: string | undefined = undefined
): string {
  if (!productId || !imageName) return "";

  // If imageName is already a full URL, return it as-is
  if (imageName.startsWith("http://") || imageName.startsWith("https://")) {
    return imageName;
  }

  const tencentCdnBase = getTencentCdnBaseUrl();
  if (additionalParams) {
    return `${tencentCdnBase}/images/products/${productId}/main/${imageName}/${imageType}_${imageResolution}?${additionalParams}`;
  }
  return `${tencentCdnBase}/images/products/${productId}/main/${imageName}/${imageType}_${imageResolution}`;
}

// Optimized image functions for different display sizes

export function getDealImageThumbnailUrlTiny(productId: string, imageName: string): string {
  return getDealImageUrl(productId, imageName, "thumbnail", "1x", "imageMogr2/crop/80x80");
}

export function getDealImageThumbnailUrlSmall(productId: string, imageName: string): string {
  return getDealImageUrl(productId, imageName, "thumbnail", "1x", "imageMogr2/crop/100x100");
}

export function getDealImageThumbnailUrlMedium(productId: string, imageName: string): string {
  return getDealImageUrl(productId, imageName, "thumbnail", "1x", "imageMogr2/crop/150x150");
}

export function getDealImagethumbnailUrlForDealCard(productId: string, imageName: string): string {
  return getDealImageUrl(productId, imageName, "thumbnail", "2x", "imageMogr2/crop/278x278");
}
